import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { useSettings, isSet, telHref, mailHref } from "../context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();

  return (
    <footer data-testid="site-footer" className="bg-anthracite text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <div className="font-heading font-black leading-[0.85] mb-5">
              <span className="block text-2xl">HP FROID</span>
              <span className="block text-xs tracking-[0.25em] text-icelight font-bold">&amp; CLIMATISATION</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Génie climatique et frigorifique en Alsace. Climatisation, PAC air/air et froid commercial pour particuliers et professionnels.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-icelight mb-5">Prestations</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/climatisation" className="hover:text-white transition-colors">Climatisation</Link></li>
              <li><Link to="/froid-commercial" className="hover:text-white transition-colors">Froid commercial</Link></li>
              <li><Link to="/entretien" className="hover:text-white transition-colors">Entretien</Link></li>
              <li><Link to="/depannage" className="hover:text-white transition-colors">Dépannage</Link></li>
              <li><Link to="/demande-de-devis" className="hover:text-white transition-colors">Demande de devis</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-icelight mb-5">Entreprise</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/entreprise" className="hover:text-white transition-colors">À propos</Link></li>
              <li><Link to="/realisations" className="hover:text-white transition-colors">Réalisations</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link></li>
              <li><Link to="/politique-de-confidentialite" className="hover:text-white transition-colors">Confidentialité</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-icelight mb-5">Coordonnées</h4>
            <ul className="space-y-4 text-sm text-white/70">
              {isSet(settings.phone) && <li className="flex items-center gap-3"><Phone size={17} className="text-icelight shrink-0" /> <a href={telHref(settings.phone)} className="hover:text-white font-semibold">{settings.phone}</a></li>}
              {isSet(settings.email) && <li className="flex items-center gap-3"><Mail size={17} className="text-icelight shrink-0" /> <a href={mailHref(settings.email)} className="hover:text-white">{settings.email}</a></li>}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} HP Froid &amp; Climatisation. Tous droits réservés.</p>
          <p>Climatisation • PAC air/air • Froid commercial — Alsace / Bas-Rhin</p>
        </div>
      </div>
    </footer>
  );
}
